/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { Modal } from '../modal'

export interface ConfirmModalProps {
  show: boolean
  title: string
  body: React.ReactNode
  confirmLabel?: string
  cancelLabel?: string
  variation?: 'warning' | 'danger'
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

/** A yes/no dialog over the shared Modal: confirm on the left, cancel on the right. */
export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  show,
  title,
  body,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variation = 'warning',
  isLoading = false,
  onConfirm,
  onCancel,
}) => (
  <Modal
    show={show}
    onHide={onCancel}
    title={title}
    bodyContent={body}
    variation={variation}
    {...{ [variation]: true }}
    footerButtons={[
      { label: confirmLabel, onClick: onConfirm, useModalVariant: true, isLoading, disabled: isLoading },
      { label: cancelLabel, onClick: onCancel, disabled: isLoading },
    ]}
  />
)

export default ConfirmModal
